/**
 * The arena envelope's payload seam.
 *
 * All 7 `arena_*` types ride ONE schemapack schema
 * (`requestId/type/arenaId/tableId/payload`, `messages.ts` /
 * `ArenaEnvelope`), and the interesting half — the status, the standings, the
 * berserk answer — is a JSON STRING in `payload`. Parsing it is the first thing
 * every arena handler does, so it is a pure helper of its own rather than three
 * copies inside the reducer (the old screen has exactly that duplication:
 * `parseArenaPayloadLocal` in the app at L2918-2926, `parseArenaPayload` on the
 * web at L2197-2205).
 */

/** `JSON.parse(data.payload || '{}')`, never throwing — {} on bad input. */
export function parseArenaPayload(data: any): any {
  try {
    return JSON.parse(data?.payload || '{}') || {};
  } catch (e: any) {
    console.warn('bad arena payload:', e?.message);
    return {};
  }
}
